module.exports = __webpack_public_path__ + "img/user-guide-03-06-02.6fa096b8.png";